import React, { useState } from 'react'
import './login.css'
import login from '../../Api/login'
import { Navigate, useNavigate } from 'react-router-dom';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async () => {
        if (!email) {
            setError("Email is required.");
            return;
        }
        if (!password) {
            setError("Password is required.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const data = await login(email, password);
            if (data?.Data?.Token) {
                navigate("/"); 
              } else {
                setError("Invalid credentials. Please try again.");
              }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
       
    } 

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }
    return (
        <>
            <div className='main'>
                <div className="login-card row">

                    {/* LEFT SIDE */}
                    <div className="login-left col-lg-7">
                        <div className="logo mb-4">
                            <img src="./assest/logoBBT.png" alt="Blueberry Travel Logo" />
                        </div>

                        <h2 >LOGIN</h2>

                        <input
                            type="email"
                            className="input-box"
                            placeholder="Email"
                            value={email}
                            onChange={handleEmailChange}
                        />

                        <div className="password-box">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="input-box"
                                placeholder="Password"
                                value={password}
                                onChange={handlePasswordChange}
                            />

                            <span
                                className="password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <i className="fas fa-eye"></i> : <i className="fas fa-eye-slash"></i>}
                            </span>
                        </div>

                        <div className="remember-forgot">
                            <label>
                                <input type="checkbox" /> Remember Me
                            </label>

                            <a href="#">Forgot Password?</a>
                        </div>

                        <button className="login-btn" onClick={handleLogin}>LOG IN</button>
                        {error && <p className="error-message text-danger">{error}</p>}
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="login-right col-lg-5">
                        <img
                            src=".\assest\Images\travel-concept-with-baggage 1.png"
                            alt="Travel"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Login